import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";

const SEOHead: React.FC = () => {
  const { currentLanguage, isRTL } = useI18n();
  const location = useLocation();

  useEffect(() => {
    // Update document language and direction
    document.documentElement.lang = currentLanguage;
    document.documentElement.dir = isRTL ? "rtl" : "ltr";

    // Update meta description based on language and page
    const updateMetaDescription = () => {
      let description = "";
      let title = "";

      if (currentLanguage === "fa") {
        // Persian meta tags
        switch (location.pathname) {
          case "/fa":
            title = "نیومی مپر - ایجاد ایالت‌ها در خاورمیانه";
            description =
              "پلتفرم تعاملی نقشه برای ایجاد ایالت‌ها در کشورهای خاورمیانه بر اساس حق اساسی انسان برای تعیین سرنوشت";
            break;
          case "/fa/faq":
            title = "سوالات متداول - نیومی مپر";
            description =
              "پاسخ سوالات رایج در مورد نیومی.سوشال و نحوه استفاده از پلتفرم ما";
            break;
          default:
            title = "نیومی مپر - ایجاد ایالت‌ها در خاورمیانه";
            description =
              "پلتفرم تعاملی نقشه برای ایجاد ایالت‌ها در کشورهای خاورمیانه";
        }
      } else {
        // English meta tags
        switch (location.pathname) {
          case "/":
            title = "NewME Mapper - Create States in Middle East";
            description =
              "Interactive map application for creating states in Middle Eastern countries based on the fundamental human right of self-determination";
            break;
          case "/faq":
            title = "FAQ - NewME Mapper";
            description =
              "Find answers to common questions about NewME.social and how to use our platform";
            break;
          default:
            title = "NewME Mapper - Create States in Middle East";
            description =
              "Interactive map application for creating states in Middle Eastern countries";
        }
      }

      // Update document title
      document.title = title;

      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      } else {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        metaDescription.setAttribute("content", description);
        document.head.appendChild(metaDescription);
      }

      // Add hreflang tags for SEO
      updateHreflangTags();
    };

    const updateHreflangTags = () => {
      // Remove existing hreflang tags
      const existingHreflang = document.querySelectorAll("link[hreflang]");
      existingHreflang.forEach((tag) => tag.remove());

      // Add hreflang tags
      const baseUrl = window.location.origin;
      const currentPath = location.pathname;

      // Determine alternate URLs
      let enUrl = "";
      let faUrl = "";

      if (currentPath.startsWith("/fa")) {
        // Currently on Persian page
        const basePath = currentPath.substring(3) || "/";
        enUrl = `${baseUrl}${basePath}`;
        faUrl = `${baseUrl}${currentPath}`;
      } else {
        // Currently on English page
        enUrl = `${baseUrl}${currentPath}`;
        faUrl = `${baseUrl}/fa${currentPath === "/" ? "" : currentPath}`;
      }

      // Add hreflang tags
      const enHreflang = document.createElement("link");
      enHreflang.setAttribute("rel", "alternate");
      enHreflang.setAttribute("hreflang", "en");
      enHreflang.setAttribute("href", enUrl);
      document.head.appendChild(enHreflang);

      const faHreflang = document.createElement("link");
      faHreflang.setAttribute("rel", "alternate");
      faHreflang.setAttribute("hreflang", "fa");
      faHreflang.setAttribute("href", faUrl);
      document.head.appendChild(faHreflang);

      // Add x-default hreflang
      const defaultHreflang = document.createElement("link");
      defaultHreflang.setAttribute("rel", "alternate");
      defaultHreflang.setAttribute("hreflang", "x-default");
      defaultHreflang.setAttribute("href", enUrl);
      document.head.appendChild(defaultHreflang);
    };

    updateMetaDescription();
  }, [currentLanguage, isRTL, location.pathname]);

  return null; // This component doesn't render anything
};

export default SEOHead;
